import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

import { formatDayLabel } from './usage-format';
import { UsageChartTooltip } from './UsageChartTooltip';
import { useChartColors } from './useChartColors';

import type { UsageDayCount } from '../../team.types';

export function MessagesBarChart({
  series,
  height,
}: {
  series: UsageDayCount[];
  height: number;
}) {
  const colors = useChartColors();
  const tickInterval = Math.max(0, Math.ceil(series.length / 7) - 1);
  return (
    <div style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={series}
          margin={{ top: 4, right: 0, bottom: 0, left: 0 }}
        >
          <CartesianGrid vertical={false} stroke={colors.gridLine} />
          <XAxis
            dataKey="date"
            tickFormatter={formatDayLabel}
            interval={tickInterval}
            axisLine={false}
            tickLine={false}
            tick={{ fill: colors.foregroundMuted, fontSize: 12 }}
          />
          <YAxis
            allowDecimals={false}
            width={32}
            tickCount={4}
            axisLine={false}
            tickLine={false}
            tick={{ fill: colors.foregroundMuted, fontSize: 12 }}
          />
          <Tooltip
            cursor={{ fill: colors.track }}
            content={({ active, payload, label }) =>
              active && payload?.length ? (
                <UsageChartTooltip>
                  <div className="font-semibold">
                    {formatDayLabel(String(label))}
                  </div>
                  <div>{Number(payload[0].value).toLocaleString()}</div>
                </UsageChartTooltip>
              ) : null
            }
          />
          <Bar dataKey="count" fill={colors.bar} radius={[3, 3, 3, 3]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
